// Calculate responsive font size based on screen width
export const   calculateFontSize = (screenWidth,maxfont,minfont) => {
    const baseSize = maxfont; // Base font size for large screens
    const minSize = minfont; // Minimum font size for very small screens
    const maxWidth = 1920; // Screen width where base size is used
    const minWidth = 320; // Screen width where min size is used
    
    if (screenWidth >= maxWidth) return baseSize;
    if (screenWidth <= minWidth) return minSize;
    
    // Linear interpolation between min and max sizes
    const ratio = (screenWidth - minWidth) / (maxWidth - minWidth);
    return Math.round(minSize + (baseSize - minSize) * ratio);
  };